import { Form, Input, InputMask, Tooltip } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

interface RegieContactListItemFormProps {
  telephone: string;
  website: string;
  mail: string;
  errors?: Record<string, string>;
  onChange: (e) => void;
}

const RegieContactListItemForm = (props: RegieContactListItemFormProps) => {
  const { errors, telephone, website, mail, onChange } = props;

  const handleChange = React.useCallback(
    (e) => {
      onChange(e);
    },
    [onChange],
  );

  return (
    <Form
      // @ts-expect-error
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Tooltip
        trigger={
          <Form.Field
            // @ts-expect-error
            style={{ width: 175 }}
          >
            <label>Téléphone</label>
            <InputMask
              data-testid="form-input-telephone"
              // @ts-expect-error
              name="telephone"
              mask="99 99 99 99 99"
              value={telephone || ''}
              icon={{ name: 'phone' }}
              onChange={handleChange}
              style={{
                width: 175,
                // Pour une raison que j'ignore, le Field veut pas se mettre en erreur..
                // Donc rustine le temps qu'on ait un champs de téléphone FW
                ...(_.has(errors, 'telephone') && { borderColor: '#96222a' }),
              }}
            />
          </Form.Field>
        }
        type={errors?.telephone ? 'error' : ''}
        message={errors?.telephone}
      />
      <Form.Field
        label="Site internet"
        data-testid="form-input-website"
        icon="globe"
        name="website"
        value={website}
        // @ts-expect-error
        control={Input}
        onChange={handleChange}
      />
      <Tooltip
        trigger={
          <Form.Input
            label="Courriel"
            data-testid="form-input-mail"
            type="email"
            icon="mail"
            name="mail"
            value={mail}
            onChange={handleChange}
          />
        }
        type={errors?.mail ? 'error' : ''}
        message={errors?.mail}
      />
    </Form>
  );
};

export default RegieContactListItemForm;
